(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["circal-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[id^="circleCatsTrack-"]').forEach(function(track) {
    var sectionSuffix = track.id.replace('circleCatsTrack-', '');
    var dotsContainer = document.getElementById('circleCatsDots-' + sectionSuffix);
    var items = track.querySelectorAll('.circle-cats__item');
    if (!items.length) return;

    var currentIndex = 0;
    var autoTimer = null;
    var autoDelay = 2500; // ms between slides

    // ── How many items fit in view? ──
    function visibleCount() {
      var wrapWidth = track.parentElement.offsetWidth;
      var itemWidth = items[0].offsetWidth + 12; // gap = 12px
      return Math.max(1, Math.floor(wrapWidth / itemWidth));
    }

    // ── Max index we can slide to ──
    function maxIndex() {
      return Math.max(0, items.length - visibleCount());
    }

    // ── Build dots ──
    function buildDots() {
      dotsContainer.innerHTML = '';
      var total = maxIndex() + 1;
      for (var i = 0; i < total; i++) {
        var btn = document.createElement('button');
        btn.className = 'circle-cats__dot' + (i === currentIndex ? ' active' : '');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function(idx) {
          btn.addEventListener('click', function() { goTo(idx); resetTimer(); });
        })(i);
        dotsContainer.appendChild(btn);
      }
    }

    // ── Update active dot ──
    function updateDots() {
      var dots = dotsContainer.querySelectorAll('.circle-cats__dot');
      dots.forEach(function(d, i) {
        d.classList.toggle('active', i === currentIndex);
      });
    }

    // ── Slide to index ──
    function goTo(idx) {
      currentIndex = Math.min(Math.max(0, idx), maxIndex());
      var itemWidth = items[0].offsetWidth + 12;
      track.style.transform = 'translateX(-' + (currentIndex * itemWidth) + 'px)';
      updateDots();
    }

    // ── Auto advance ──
    function startTimer() {
      autoTimer = setInterval(function() {
        var next = currentIndex >= maxIndex() ? 0 : currentIndex + 1;
        goTo(next);
      }, autoDelay);
    }

    function resetTimer() {
      clearInterval(autoTimer);
      startTimer();
    }

    // ── Touch / swipe support ──
    var touchStartX = 0;
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      clearInterval(autoTimer);
    }, { passive: true });

    track.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
      startTimer();
    }, { passive: true });

    // ── Recalculate on resize ──
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        buildDots();
        goTo(0);
      }, 200);
    });

    // ── Init ──
    buildDots();
    goTo(0);
    startTimer();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
